import {
  FILECONLIST,
} from 'actions/filecon';
import {reducerPackage} from "../../utils";

export const fileconList = reducerPackage(FILECONLIST);
